module.exports = __webpack_public_path__ + "static/media/gcdef_10040.3a8d773f.ico";